<template>
<div class="wrapper-content fadeInRight animated tabBox" id="rescuedrive-list">
    <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		<!--表单查询开始-->
		<div class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-1 control-label">总部单号</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.requestCode">
				</div>
				<label class="col-sm-1 control-label">救援单号</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.rescueOrderNo">
				</div>
				<label class="col-sm-1 control-label">请求开始时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': validDates }">
					<datepicker v-model="queryParam.beginDate" class="form-control" ref="startTime"></datepicker>
					<p v-if="validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">请求结束时间</label>
				<div class="col-sm-2" v-bind:class="{ 'form-group--error': validDates }">
					<datepicker v-model="queryParam.endDate" class="form-control" ref="endTime"></datepicker>
					<p v-if="validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">返回信息</label>
				<div class="col-sm-2">
					<input class="form-control" v-model.trim="queryParam.responseData">
				</div>
				<label class="col-sm-1 control-label">推送状态</label>
				<div class="col-sm-2">
					<select class="form-control" v-model="queryParam.isSuccess">
						<option value="" >全部</option>
						<option v-for="(item, index) in is_successList" v-bind:value="item.code" :key="index">
							{{item.name}}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button :disabled="validDates" type="button" class="btn btn-primary" @click="searchInfo">查询</button>
					<button type="button" class="btn btn-primary"  @click="resetQueryParams">重置</button>
				</div>
			</div>
			<div class="hr-line-dashed"></div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button type="button" @click="repushbtn" class="btn btn-primary">一键重推</button>
					<button type="button" @click="openModalImport" class="btn btn-primary">导入</button>
				</div>
			</div>
		</div>
		<!--表单查询结束-->
		<!--表格开始-->
		<div class="location_table" style="overflow: hidden;width:100%; position: relative;">
			<div style="overflow: auto;">
				<table style="min-width:1600px;" class="table table-striped table-bordered">
					<thead>
						<tr>
							<th>总部单号</th>
							<th>救援单号</th>
							<th>救援价格</th>
							<th>推送状态</th>
							<th>返回信息</th>
							<th>更新时间</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(fileInfo,index) in orderList" v-bind:key="index">
							<td>{{fileInfo.requestCode}}</td>
							<td>{{fileInfo.rescueOrderNo}}</td>
							<td>{{accDiv(fileInfo.closingCost,100)}}</td>
							<td>{{fileInfo.isSuccess == 0 ? '失败' : '成功' }}</td>
							<td>{{fileInfo.responseData}}</td>
							<td>{{fileInfo.updateTime}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!--分页组件开始-->
		<pagination v-if="orderList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		<!--分页组件结束-->
		<tab-modal ref="modalImport" size="modal" :scroll='scrollTop' title="提示" v-on:cancel="closeModalImport">
			<ul class="improtTabUl">
				<li>
					请下载：<a @click="downFeedBack">运维工具模板</a>
				</li>
				<li>
					<el-upload
						:action="picUrl"
						:headers="{'access-token':this.accesstoken}"
						:limit='1'
						:before-upload="beforeupload"
						:file-list="fileList"
						:on-exceed="imgExceed"
						:on-success='fileSuccess'
						>
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">请上传Excel类型文件</div>
					</el-upload>
				</li>
			</ul>
		</tab-modal>
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</div>
</template>
<script>
	import Pagination from 'components/common/Pagination'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
	import Datepicker from 'components/common/datepicker/Datepicker'
	export default {
		name: "PageRescueDriverList",
		components: {
			Pagination,
			TabModal,
			Datepicker
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["rescueDriverList"]?this.$store.state.permission.permission["rescueDriverList"]:[],
				loadingstatus:false,
				showSubPage: false,
				pageInfo:{},	                                        //分页所需信息
				orderList: [], 		                                    //表格数据列表
				messageStr: "",					                        // 弹出框内容
				scrollTop: '',
				queryParam:{
					requestCode: "",									
					rescueOrderNo: "",
					isSuccess: "",
					endDate: "",		                                
					beginDate: "",						        	
					page_index: 1,                                  
					                     
				},
				is_successList: [
					{name: '成功' ,code: 1},
					{name: '失败' ,code: 0}
				],
				picUrl:process.env.API_INSURANCE_ROOT +"/rescue-api/cost-feedback/import",
				modalImport: false,
				fileList: []
			};
		},
		computed: {
			accesstoken:function(){
				return this.$store.state.user.accesstoken
			},
			validDates () {
				if (this.queryParam.beginDate && this.queryParam.endDate) {
					return this.queryParam.beginDate > this.queryParam.endDate
				} else {
					return false
				}
			},
		},
		watch:{

		},
		beforeMount () {
			this.getTableInfo();
		},
		methods: {
			//查询方法
			searchInfo(){
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			// 获取列表信息
			getTableInfo() {
				this.loadingstatus = true;
				this.$http.post(process.env.API_INSURANCE_ROOT  + '/rescue-api/cost-feedback/page',this.queryParam)
					.then( res => {
						if(res.body.success){
							const resInfo = res.body.data;
							const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
							this.pageInfo = {
								pageNum: pageNum,
								pages: pages,
								total: total,
								isFirstPage: isFirstPage,
								isLastPage: isLastPage
							}
							this.orderList = resInfo.list;
							this.loadingstatus = false;
						} else {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			// 除法精度丢失
			accDiv(arg1, arg2) {
				if(arg1 == null){
					return null;
				}
				if(arg2 == null || arg2 == 0){
					return null;
				}
				var n1,n2;
				var r1, r2; // 小数位数
				try {
					r1 = arg1.toString().split(".")[1].length;
				} catch (e) {
					r1 = 0;
				}
				try {
					r2 = arg2.toString().split(".")[1].length;
				} catch (e) {
					r2 = 0;
				}
				n1 = Number(arg1.toString().replace(".", ""));
				n2 = Number(arg2.toString().replace(".", ""));
				return (n1 / n2) * Math.pow(10, r2 - r1);
			},
			// 一键重推
			repushbtn () {
				this.loadingstatus = true;
				this.$http.post(process.env.API_INSURANCE_ROOT  + '/rescue-api/cost-feedback/feedbackAgain')
					.then( res => {
						if(res.body.success){
							this.loadingstatus = false
							this.queryParam.page_index = 1
							this.$message({type:'success',message:'重推成功'})
							this.getTableInfo()
						} else {
							this.openModalMsg(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//从分页组件获取页码参数
			getPageNo(param) {
				this.queryParam.page_index = param;
				this.getTableInfo();
			},
			//重置信息
			resetQueryParams:function(){
				this.queryParam = {
					requestCode: '',
					rescueOrderNo: '',
					beginDate: '',
					endDate: '',
					responseData: '',
					isSuccess: '',
					page_index: 1
				}
			},
			// 消息弹出框相关
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#rescuedrive-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#rescuedrive-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
			// 导入弹窗
			closeModalImport(){
        		this.closeModal("modalImport");
        	},
        	openModalImport(){
        		this.openModal("modalImport")
        	},
			// 导入限制
			imgExceed(files, fileList){
				if(fileList.length === 1){
					this.$message({type:'error',message:'最多上传一份文件'})
				}
			},
			//限制图片大小
			beforeupload(file){
				const isexcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||  file.type === 'application/vnd.ms-excel'
				if (!isexcel) {
					this.$message.error('请上传excel类型的文件');
				}
				return isexcel
			},
			// 导入文件成功
			fileSuccess (res, file, fileList) {
				this.queryParam.page_index = 1
				this.$message({type:'success',message:'导入成功'})
				this.closeModalImport()
				this.getTableInfo()
			},
			// 下载模板：/api/noauth/cost-feedback/export
			downFeedBack () {
				var path = process.env.EXPORT_PATH;
				var api = process.env.API_ROOT;
				var fileName = path  + api + '/noauth/cost-feedback/export'
				var elemIF = document.createElement("iframe");   
				elemIF.src = fileName;   
				elemIF.style.display = "none";   
				document.body.appendChild(elemIF); 
			}
		}
	}
</script>

<style scoped>
.improtTabUl {
	list-style: none;
}
.improtTabUl li {
	list-style: none;
	margin-bottom: 10px;
}
</style>
<style>
.el-upload__input {
	display: none !important;
}
</style>



// WEBPACK FOOTER //
// PageCostFeedback.vue?2dd8abb8